import { render, staticRenderFns } from "./ContactPreferences.vue?vue&type=template&id=60aec7d8&scoped=true&"
import script from "./ContactPreferences.vue?vue&type=script&lang=ts&"
export * from "./ContactPreferences.vue?vue&type=script&lang=ts&"
import style0 from "./ContactPreferences.vue?vue&type=style&index=0&id=60aec7d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aec7d8",
  null
  
)

export default component.exports